import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserObj } from '../../../classes/user-obj';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthorizatorService } from '../../../services/authorizator.service';

export interface DialogData {
  type: string;
  user: UserObj;
  rootFirebasePath: string;
}

@Component({
  selector: 'lib-upsert-user',
  templateUrl: './upsert-user.component.html',
  styleUrls: ['./upsert-user.component.scss']
})
export class UpsertUserComponent {
  public userForm = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email])
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private authorizatorservice: AuthorizatorService,
    public dialogRef: MatDialogRef<UpsertUserComponent>
  ) { }

  onSubmitUser() {
    if (this.userForm.valid) {
      const userToAdd: UserObj = {
        id: this.userForm.controls.email.value,
        data: {
          name: null,
          email: this.userForm.controls.email.value,
          picture: null,
          permissions: null
        }
      };
      this.authorizatorservice.addUser(this.data.rootFirebasePath, userToAdd).then(() => {
        this.dialogRef.close(userToAdd);
      }).catch(error => {
        if (error.key === 'exists') {
          this.userForm.controls.email.setErrors({ exists: true });
        } else {
          this.userForm.controls.email.setErrors({ defaulterror: true });
        }
      });
    }
  }
}
